import { createSlice } from "@reduxjs/toolkit";
import {
  getPaddyBuyerList,
  getFarmerGroupLeaderList,
  getPaddyBuyerSubDistrict,
} from "./action";

const initialState = {
  paddyBuyerList: [],
  paddyBuyerTotalCount: 0,
  isPaddyBuyerLoading: false,
  farmerGroupLeaderList: [],
  farmerGroupTotalCount: 0,
  isFarmerGroupLeaderLoading: false,
  subDistrictList: [],
  isSubDistrictLoading: false,
};

const stakeholderSlice = createSlice({
  name: "stakeholder",
  initialState,
  reducers: {
    initStakeholdersState(state, action) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPaddyBuyerList.pending, (state, action) => {
        state.isPaddyBuyerLoading = true;
        state.paddyBuyerList = [];
        state.paddyBuyerTotalCount = 0;
        return state;
      })
      .addCase(getPaddyBuyerList.fulfilled, (state, action) => ({
        ...state,
        isPaddyBuyerLoading: false,
        paddyBuyerList: action.payload.data,
        paddyBuyerTotalCount: action.payload.totalCount,
      }))
      .addCase(getPaddyBuyerList.rejected, (state, action) => {
        state.isPaddyBuyerLoading = false;
      });

    builder
      .addCase(getFarmerGroupLeaderList.pending, (state, action) => {
        state.isFarmerGroupLeaderLoading = true;
        state.farmerGroupLeaderList = [];
        state.farmerGroupTotalCount = 0;
        return state;
      })
      .addCase(getFarmerGroupLeaderList.fulfilled, (state, action) => ({
        ...state,
        isFarmerGroupLeaderLoading: false,
        farmerGroupLeaderList: action.payload.data,
        farmerGroupTotalCount: action.payload.totalCount,
      }))
      .addCase(getFarmerGroupLeaderList.rejected, (state, action) => {
        state.isFarmerGroupLeaderLoading = false;
      });

    builder
      .addCase(getPaddyBuyerSubDistrict.pending, (state, action) => {
        state.isSubDistrictLoading = true;
        state.subDistrictList = [];
        return state;
      })
      .addCase(getPaddyBuyerSubDistrict.fulfilled, (state, action) => ({
        ...state,
        isSubDistrictLoading: false,
        subDistrictList: action.payload,
      }))
      .addCase(getPaddyBuyerSubDistrict.rejected, (state, action) => {
        state.isSubDistrictLoading = false;
      });
  },
});

export const { initStakeholdersState } = stakeholderSlice.actions;

export default stakeholderSlice.reducer;
